import { observer } from 'mobx-react'
import * as React from 'react'
import { FieldNo } from '../../atoms/FieldNo'
import { HideTablet } from '../../atoms/HideTablet'
import { IntakeStepCol } from '../../atoms/IntakeStepCol'
import { IntakeStepContainer } from '../../atoms/IntakeStepContainer'
import { IntakeStepNoColTablet } from '../../atoms/IntakeStepNoColTablet'
import { Label } from '../../atoms/Label'
import { Scale } from '../../atoms/Scale'
import {
  GetOwnIntakeQuery_getOwnIntake, UpdateOwnIntakeMutationVariables,
} from '../../schema/schemaTypes'
import styled from 'styled-components'

interface IProps {
  id: string
  active: boolean
  handleSubmit: (vars: UpdateOwnIntakeMutationVariables) => void
  intake: GetOwnIntakeQuery_getOwnIntake
  isCompleted: boolean
  label: string
  name: string
  fromLabel?: string
  toLabel?: string
  no: number
  scaleFrom?: number
  scaleTo?: number
}

export const IntakeStepScale = observer(
  ({ active, handleSubmit, intake, id, isCompleted, label, name, no, scaleFrom, scaleTo, fromLabel, toLabel }: IProps) => (
    <IntakeStepContainer id={id} active={active}>
      <IntakeStepNoColTablet>
        <FieldNo checked={isCompleted}>{no}</FieldNo>
      </IntakeStepNoColTablet>
      <IntakeStepCol>
        <div>
          <Label><HideTablet><FieldNo checked={isCompleted}>{no}</FieldNo></HideTablet>{label}</Label>
          <Scale from={scaleFrom || 0} to={scaleTo || 10} disabled={!active}
          fromLabel={fromLabel} toLabel={toLabel}
            // tslint:disable-next-line:jsx-no-lambda
            value={intake[name] || null} onChange={value => handleSubmit({ [name]: value })} />
        </div>
        </IntakeStepCol>
    </IntakeStepContainer>
  ))

const Labels = styled.div`
  margin-top: 7px;
  display: flex;
  justify-content: space-between;

  font-family: "SF Pro Display";
  font-size: 14px;
  color: #AEBFCC;
`



// WEBPACK FOOTER //
// ./src/organisms/Intakes/IntakeStepScale.tsx